import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/Terms.module.css";
import { EULA_URL } from "../utils/legal";

const AboutUs = () => {
  return (
    <div className={styles.container}>
      <div className={styles.intro}>
        <div className={styles.introText}>
          <h1>Rigrestr</h1>
          <h2>Your Trusted Rest-Stop Finder on the Road</h2>

          <h3>
            Rigrestr is a smart, reliable navigation companion built specifically for truckers. Long hours on the road can be exhausting, and finding a safe, nearby place to rest shouldn't be difficult. Rigrestr helps drivers instantly locate the closest resting spots, parking areas, and safe pull-over locations — all in real time.
          </h3>

          <h3>
            Designed for convenience and ease of use, Rigrestr ensures truckers never waste time searching for a place to stop. Whether you need a quick break or a full rest period, the app guides you to the nearest available options with accurate location details.
          </h3>

          <h2>I AGREE to the EULA</h2>
          <h3>
            By downloading, accessing, subscribing, or using RigRestR, you
            agree to the{" "}
            <a href={EULA_URL} target="_blank" rel="noopener noreferrer">
              End User License Agreement (EULA)
            </a>
            , our <Link to="/terms">Terms of Service</Link>, and our{" "}
            <Link to="/privacy">Privacy Policy</Link>.
          </h3>

          <h2>Key Features</h2>

          <h3>
            <strong>Find the Nearest Resting Places:</strong> Instantly see rest stops, parking areas, and safe spots based on your current location.
          </h3>

          <h3>
            <strong>Simple and Clean Interface:</strong> Built for truckers who need fast, distraction-free access while on the road.
          </h3>

          <h3>
            <strong>Accurate Location Services:</strong> Uses your provided location to show you the closest resting points.
          </h3>

          <h3>
            <strong>Lightweight and Fast:</strong> No clutter, no complications — just the essential information you need.
          </h3>

          <h3>
            <strong>User-Friendly Experience:</strong> Designed to make long-distance trucking safer, easier, and more comfortable.
          </h3>

          <h2>RigRestR Pro</h2>

          <h3>
            <strong>Pro Monthly — $20/month:</strong> Unlimited location views, all truck stops, rest areas &amp; parking, add &amp; report locations, and priority support. New subscribers get a free trial.
          </h3>

          <h3>
            <strong>Pro Annual — $199/year:</strong> Everything in Pro Monthly for a full year. Best value — save $41 compared to paying monthly.
          </h3>

          <h3>
            Pro subscriptions are billed through the Apple App Store or Google Play and renew automatically unless cancelled. You can manage or cancel anytime from your store account settings.
          </h3>

          <h2>Why Rigrestr?</h2>

          <h3>
            Truckers spend long hours driving and often struggle to find safe places to stop. Rigrestr solves this problem by providing a quick and reliable way to locate the nearest rest area, allowing drivers to stay safe, rested, and compliant with road regulations.
          </h3>

          <h3>
            <strong>Stay safe. Stay rested.</strong>
            <br />
            Rigrestr — Your trusted rest-stop finder on the road.
          </h3>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
